var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(" 账本"),
            _c("b", [_vm._v("只增不改")]),
            _vm._v(
              "：冲正是另写一行并回填「冲正流水号」，原始行永远保持发生时的样子。 所以对账时按时间区间求和得到的就是那段时间的真实净额，不需要排除任何行。 "
            ),
            _c("br"),
            _vm._v(" 账户余额与账本对不上时，以"),
            _c("b", [_vm._v("账本")]),
            _vm._v("为准 —— 余额是汇总出来的结果。 "),
          ]),
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.onTabChange },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "积分账户", name: "account" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { inline: "", size: "small" },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系方式" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidthSm",
                            attrs: { placeholder: "手机号", clearable: "" },
                            model: {
                              value: _vm.accountQuery.contact,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.accountQuery,
                                  "contact",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "accountQuery.contact",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.loadAccounts(1)
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            { on: { click: _vm.resetAccounts } },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.accountLoading,
                          expression: "accountLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.accountList,
                        size: "small",
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "序号", width: "60", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                            },
                          },
                        ]),
                      }),
                      false
                        ? _c("el-table-column", {
                            attrs: { prop: "id", label: "ID", width: "70" },
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: { label: "用户", "min-width": "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.userName(_vm.accountUsers, row.uid)
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "sub-line" }, [
                                  _vm._v(
                                    "uid " +
                                      _vm._s(row.uid) +
                                      _vm._s(
                                        _vm.userPhone(_vm.accountUsers, row.uid)
                                      )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "available",
                          label: "可用",
                          width: "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "frozen", label: "冻结", width: "110" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "totalEarned",
                          label: "累计获得",
                          width: "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "totalUsed",
                          label: "累计使用",
                          width: "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "totalExpired",
                          label: "累计过期",
                          width: "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "80" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type:
                                        row.status === 1 ? "success" : "danger",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.status === 1 ? "正常" : "冻结"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "updateTime",
                          label: "更新时间",
                          "min-width": "150",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "90", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewLedger(row.uid)
                                      },
                                    },
                                  },
                                  [_vm._v("查账本")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "pager" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          layout: "total, sizes, prev, pager, next, jumper",
                          "page-sizes": [10, 20, 50, 100],
                          "page-size": _vm.accountQuery.size,
                          "current-page": _vm.accountQuery.page,
                          total: _vm.accountTotal,
                        },
                        on: {
                          "size-change": _vm.onAccountSize,
                          "current-change": _vm.loadAccounts,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "积分账本", name: "ledger" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { inline: "", size: "small" },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户uid" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidthSm",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.ledgerQuery.uid,
                              callback: function ($$v) {
                                _vm.$set(_vm.ledgerQuery, "uid", _vm._n($$v))
                              },
                              expression: "ledgerQuery.uid",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "方向" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidthSm",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.ledgerQuery.direction,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ledgerQuery, "direction", $$v)
                                },
                                expression: "ledgerQuery.direction",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "收入", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "支出", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "冻结", value: 3 },
                              }),
                              _c("el-option", {
                                attrs: { label: "解冻", value: 4 },
                              }),
                              _c("el-option", {
                                attrs: { label: "过期", value: 5 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.ledgerQuery.sourceType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ledgerQuery, "sourceType", $$v)
                                },
                                expression: "ledgerQuery.sourceType",
                              },
                            },
                            _vm._l(_vm.SOURCE, function (text, key) {
                              return _c("el-option", {
                                key: key,
                                attrs: { label: text, value: key },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "单号" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "流水号 / 业务号 / 核销单号",
                              clearable: "",
                            },
                            model: {
                              value: _vm.ledgerQuery.keyword,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ledgerQuery,
                                  "keyword",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "ledgerQuery.keyword",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "时间" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                              "start-placeholder": "开始",
                              "end-placeholder": "结束",
                            },
                            model: {
                              value: _vm.dateRange,
                              callback: function ($$v) {
                                _vm.dateRange = $$v
                              },
                              expression: "dateRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.loadLedger(1)
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _c("el-button", { on: { click: _vm.resetLedger } }, [
                            _vm._v("重置"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.ledgerLoading,
                          expression: "ledgerLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.ledgerList,
                        size: "small",
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "序号", width: "60", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "transactionId",
                          label: "流水号",
                          "min-width": "180",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "用户", "min-width": "160" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.userName(_vm.ledgerUsers, row.uid)
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "sub-line" }, [
                                  _vm._v("uid " + _vm._s(row.uid)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "方向", width: "80" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: _vm.directionTagType(row.direction),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.directionText(row.direction)
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "amount", label: "积分", width: "100" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "可用余额", width: "140" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  _vm._s(row.beforeAvailable) +
                                    " → " +
                                    _vm._s(row.afterAvailable)
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "来源", "min-width": "130" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(_vm._s(_vm.sourceText(row.sourceType))),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sourceId",
                          label: "来源单号",
                          "min-width": "170",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "reversalNo",
                          label: "冲正流水号",
                          "min-width": "170",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "时间",
                          "min-width": "150",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "pager" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          layout: "total, sizes, prev, pager, next, jumper",
                          "page-sizes": [10, 20, 50, 100],
                          "page-size": _vm.ledgerQuery.size,
                          "current-page": _vm.ledgerQuery.page,
                          total: _vm.ledgerTotal,
                        },
                        on: {
                          "size-change": _vm.onLedgerSize,
                          "current-change": _vm.loadLedger,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }